import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CommentUpdate,
  brandCommentSaver,
  designStatusSaver,
} from "../../../../Redux/actions/Srt/Srt";
import "../../../../UIComponents/CustomDropDown/CustomDropDown.css";
import { Button, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useMsal } from "@azure/msal-react";

const CustomDropDown = ({
  data,
  defaultValue,
  requestNo,
  rowData,
  disabled,
  salesSample,
}) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [TooltipInputText, setTooltipInputText] = useState("");
  const [commentUpdateReqData, setCommentUpdateReqData] = useState({});
  const profileDetailData = useSelector(
    (state) => state?.Profile?.profileDetails?.role
  );
  const userDetails = useSelector((state) => state?.Profile?.profileDetails);
  const userNameMicrosoft = useSelector(
    (state) => state?.Profile?.graphCompleteData?.displayName
  );
  const brandNameFromApi = useSelector((state) => state?.Srt?.srtBrandNames);

  const [filteredUserName, setFilteredUserName] = useState("");
  const [filteredUserId, setFilteredUserId] = useState("");
  const [overrideStatus, setOverideStatus] = useState("");

  const [dropDownValue, setDropDownValue] = useState("");
  const [comment_count, setCommentCount] = useState("");

  useEffect(() => {
    if (
      defaultValue == null ||
      defaultValue === undefined ||
      defaultValue == "" ||
      defaultValue == " "
    ) {
      setDropDownValue(" ");
    } else if (defaultValue !== dropDownValue) {
      setDropDownValue(defaultValue);
    }
    setTooltipInputText("");
    if (data?.qa_cmt && Array?.isArray(data?.qa_cmt)) {
      data?.qa_cmt?.map((item, index) => {
        if (item?.username === userNameMicrosoft) {
          setFilteredUserName(item?.username);
          setFilteredUserId(item?.id);
          setTooltipInputText(item?.comments);
          setCommentCount(item?.comment_count);
        }
      });
    }
  }, [data]);
  useEffect(() => {
    if (
      defaultValue == null ||
      defaultValue === undefined ||
      defaultValue == "" ||
      defaultValue == " "
    ) {
      setDropDownValue(" ");
    }
  }, []);
  const toolTipCommentsData = () => {
    return {
      style: rowData?.style,
      brand: rowData?.brand,
      factory: rowData?.factory,
      season: rowData?.season,
      color_code: rowData?.color_code,
      request_no: requestNo,
      size: commentUpdateReqData?.size,
      comments: TooltipInputText,
      username: userNameMicrosoft,
      role_name: userDetails?.role,
      comment_type: "QA",
      comment_count: 0,
      sale_sample: salesSample,
    };
  };

  const toolTipCommentsUpdateData = () => {
    return {
      style: rowData?.style,
      brand: rowData?.brand,
      factory: rowData?.factory,
      season: rowData?.season,
      color_code: rowData?.color_code,
      request_no: requestNo,
      size: commentUpdateReqData?.size,
      comments: TooltipInputText,
      username: userNameMicrosoft,
      role_name: userDetails?.role,
      comment_count,
      id: filteredUserId,
      comment_type: "QA",
      sale_sample: salesSample,
    };
  };
  const matchedRequestDetail = rowData?.request_details?.find(
    (req) => req?.request_no === requestNo
  );
  const onDropChange = (e, requestNo, rowData) => {
    setCommentUpdateReqData(rowData);
    let item = e.target.options[e.target.selectedIndex];
    let color = item.getAttribute("color");
    e.target.style.backgroundColor = color;

    if (data?.Qty == 0) {
      setDropDownValue(e.target.value);
    }
    if (e.target.value === "Override") {
      setOverideStatus(e.target.value);
    } else if (e.target.value === "Rejected") {
      setOverideStatus("");
    }
    if (e.target.value === "Rejected" || e.target.value === "Override") {
      setIsModalOpen(true);
    } else if (profileDetailData !== "Admin" || profileDetailData !== "QA") {
      setDropDownValue(e.target.value);
      setOverideStatus();
      dispatch(
        designStatusSaver(
          rowData?.style,
          rowData?.brand,
          rowData?.factory,
          rowData?.size,
          rowData?.season,
          rowData?.color_code,
          requestNo,
          matchedRequestDetail?.brand_status,
          matchedRequestDetail?.design_status,
          matchedRequestDetail?.pd_status,
          e.target.value,
          salesSample,
          userNameMicrosoft,
          brandNameFromApi
        )
      );
    }
  };
  useEffect(() => {
    if (data?.qa_cmt && Array.isArray(data?.qa_cmt)) {
      data?.qa_cmt?.map((item, index) => {
        if (item?.username === userNameMicrosoft) {
          setFilteredUserName(item?.username);
          setFilteredUserId(item?.id);
          setTooltipInputText(item?.comments);
          setCommentCount(item?.comment_count);
        }
      });
    }
  }, [isModalOpen]);
  const handleCancel = () => {
    setIsModalOpen(false);
    setTooltipInputText("");
    setOverideStatus("");
    setHasInvalidAscii(false);
  };
  const onSaveHandle = () => {
    if (!TooltipInputText) {
      toast.error("Please add the comment");
      return;
    }
    setIsModalOpen(false);
    const statusToSet = overrideStatus ? "Override" : "Rejected";
    setDropDownValue(statusToSet);

    dispatch(
      designStatusSaver(
        rowData?.style,
        rowData?.brand,
        rowData?.factory,
        rowData?.size,
        rowData?.season,
        rowData?.color_code,
        requestNo,
        matchedRequestDetail?.brand_status,
        matchedRequestDetail?.design_status,
        matchedRequestDetail?.pd_status,
        statusToSet,
        salesSample,
        userNameMicrosoft,
        brandNameFromApi
      )
    );

    setTimeout(() => {
      if (
        profileDetailData !== "Admin" &&
        profileDetailData !== "QA" &&
        filteredUserName === userNameMicrosoft
      ) {
        dispatch(CommentUpdate(toolTipCommentsUpdateData(), brandNameFromApi));
      } else if (data?.qa_cmt && data.qa_cmt.length === 0) {
        dispatch(brandCommentSaver(toolTipCommentsData(), brandNameFromApi));
      } else {
        dispatch(CommentUpdate(toolTipCommentsUpdateData(), brandNameFromApi));
      }
      // setOverideStatus();
    }, 2000);
    setOverideStatus("");
  };
  // const onSaveHandle = () => {
  //   if (!TooltipInputText) {
  //     toast.error("Please add the comment");
  //   }
  //   if (
  //     (profileDetailData !== "Admin" || profileDetailData !== "QA") &&
  //     filteredUserName === userNameMicrosoft
  //   ) {
  //     setIsModalOpen(false);
  //     if (overrideStatus) {
  //       setDropDownValue("Override");
  //       dispatch(
  //         designStatusSaver(
  //           rowData?.style,
  //           rowData?.brand,
  //           rowData?.factory,
  //           rowData?.size,
  //           rowData?.season,
  //           rowData?.color_code,
  //           requestNo,
  //           "",
  //           "",
  //           "",
  //           "Override",
  //           salesSample,
  //           userNameMicrosoft,
  //           brandNameFromApi
  //         )
  //       );
  //       setTimeout(() => {
  //         dispatch(
  //           CommentUpdate(toolTipCommentsUpdateData(), brandNameFromApi)
  //         );
  //         setOverideStatus();
  //       }, 2000);
  //     } else {
  //       setDropDownValue("Rejected");
  //       dispatch(
  //         designStatusSaver(
  //           rowData?.style,
  //           rowData?.brand,
  //           rowData?.factory,
  //           rowData?.size,
  //           rowData?.season,
  //           rowData?.color_code,
  //           requestNo,
  //           "",
  //           "",
  //           "",
  //           "Rejected",
  //           salesSample,
  //           userNameMicrosoft,
  //           brandNameFromApi
  //         )
  //       );
  //       setTimeout(() => {
  //         dispatch(
  //           CommentUpdate(toolTipCommentsUpdateData(), brandNameFromApi)
  //         );
  //       }, 2000);
  //     }
  //   } else {
  //     setIsModalOpen(false);
  //     if (overrideStatus) {
  //       setDropDownValue("Override");
  //       dispatch(
  //         designStatusSaver(
  //           rowData?.style,
  //           rowData?.brand,
  //           rowData?.factory,
  //           rowData?.size,
  //           rowData?.season,
  //           rowData?.color_code,
  //           requestNo,
  //           "",
  //           "",
  //           "",
  //           "Override",
  //           salesSample,
  //           userNameMicrosoft,
  //           brandNameFromApi
  //         )
  //       );
  //       setTimeout(() => {
  //         dispatch(brandCommentSaver(toolTipCommentsData(), brandNameFromApi));
  //         setOverideStatus();
  //       }, 2000);
  //     } else {
  //       setDropDownValue("Rejected");
  //       dispatch(
  //         designStatusSaver(
  //           rowData?.style,
  //           rowData?.brand,
  //           rowData?.factory,
  //           rowData?.size,
  //           rowData?.season,
  //           rowData?.color_code,
  //           requestNo,
  //           "",
  //           "",
  //           "",
  //           "Rejected",
  //           salesSample,
  //           userNameMicrosoft,
  //           brandNameFromApi
  //         )
  //       );
  //       setTimeout(() => {
  //         dispatch(brandCommentSaver(toolTipCommentsData(), brandNameFromApi));
  //       }, 2000);
  //     }
  //   }
  // };
  const VALID_CHAR_REGEX = /^[\x09\x0A\x0D\x20-\x7E]*$/;
  const [hasInvalidAscii, setHasInvalidAscii] = useState(false);

  const ontooltipInputTextChange = (e) => {
    const input = e.target.value;
    const containsInvalidAscii = !VALID_CHAR_REGEX.test(input);
    setHasInvalidAscii(containsInvalidAscii);
    setTooltipInputText(input);
  };

  return (
    <div>
      <div className="custom-drop-down">
        <select
          disabled={disabled}
          onChange={(e) => onDropChange(e, requestNo, rowData)}
          id="drop"
          // style={{
          //   backgroundColor:
          //     dropDownValue == "Approved"
          //       ? "#96CFBE"
          //       : dropDownValue == "Override"
          //       ? "#f4e3b5"
          //       : dropDownValue == "Rejected"
          //       ? "#f8ccd4"
          //       : dropDownValue == "Incomplete"
          //       ? "#85ceff"
          //       : dropDownValue == "N/A"
          //       ? "#e8e9ee"
          //       : "#e6f4ff",
          // }}
          // defaultValue={defaultValue}
          // value={dropDownValue}
          style={{
            backgroundColor:
              (dropDownValue || defaultValue) == "Approved"
                ? "#96CFBE"
                : (dropDownValue || defaultValue) == "Override"
                ? "#f4e3b5"
                : (dropDownValue || defaultValue) == "Rejected"
                ? "#f8ccd4"
                : (dropDownValue || defaultValue) == "Incomplete"
                ? "#85ceff"
                : (dropDownValue || defaultValue) == "N/A"
                ? "#e8e9ee"
                : "#e6f4ff",
          }}
          value={dropDownValue || defaultValue || "-"}
        >
          <option
            style={{ backgroundColor: "#e6f4ff" }}
            color="#e6f4ff"
            value="null"
          >
            -
          </option>
          <option
            style={{ backgroundColor: "#96CFBE" }}
            color={
              dropDownValue == "Approved"
                ? "#96CFBE"
                : dropDownValue == "Override"
                ? "#f4e3b5"
                : dropDownValue == "Rejected"
                ? "#f8ccd4"
                : dropDownValue == "Incomplete"
                ? "#85ceff"
                : dropDownValue == "N/A"
                ? "#e8e9ee"
                : "#e6f4ff"
            }
            value="Approved"
            name="Approved"
          >
            Approved
          </option>
          <option
            style={{ backgroundColor: "#f4e3b5" }}
            color={
              dropDownValue == "Approved"
                ? "#96CFBE"
                : dropDownValue == "Override"
                ? "#f4e3b5"
                : dropDownValue == "Rejected"
                ? "#f8ccd4"
                : dropDownValue == "Incomplete"
                ? "#85ceff"
                : dropDownValue == "N/A"
                ? "#e8e9ee"
                : "#e6f4ff"
            }
            value="Override"
            name="Override"
          >
            Override
          </option>
          <option
            style={{ backgroundColor: "#f8ccd4" }}
            color={
              dropDownValue == "Approved"
                ? "#96CFBE"
                : dropDownValue == "Override"
                ? "#f4e3b5"
                : dropDownValue == "Rejected"
                ? "#f8ccd4"
                : dropDownValue == "Incomplete"
                ? "#85ceff"
                : dropDownValue == "N/A"
                ? "#e8e9ee"
                : "#e6f4ff"
            }
            value="Rejected"
            name="Rejected"
          >
            Rejected
          </option>
          <option
            style={{ backgroundColor: "#85ceff" }}
            color={
              dropDownValue == "Approved"
                ? "#96CFBE"
                : dropDownValue == "Override"
                ? "#f4e3b5"
                : dropDownValue == "Rejected"
                ? "#f8ccd4"
                : dropDownValue == "Incomplete"
                ? "#85ceff"
                : dropDownValue == "N/A"
                ? "#e8e9ee"
                : "#e6f4ff"
            }
            value="Incomplete"
            name="Incomplete"
          >
            Incomplete
          </option>
          <option
            style={{ backgroundColor: "#e8e9ee" }}
            color={
              dropDownValue == "Approved"
                ? "#96CFBE"
                : dropDownValue == "Override"
                ? "#f4e3b5"
                : dropDownValue == "Rejected"
                ? "#f8ccd4"
                : dropDownValue == "Incomplete"
                ? "#85ceff"
                : dropDownValue == "N/A"
                ? "#e8e9ee"
                : "#e6f4ff"
            }
            value="N/A"
            name="N/A"
          >
            N/A
          </option>
        </select>
      </div>
      <Modal
        title="Comment"
        open={isModalOpen}
        onCancel={handleCancel}
        okText={"save"}
        footer={null}
      >
        <TextArea
          value={TooltipInputText}
          rows={4}
          onChange={ontooltipInputTextChange}
        />
        {hasInvalidAscii && (
          <p style={{ color: "red", fontWeight: "bold" }}>
            Invalid characters detected: Only printable ASCII characters are
            allowed.
          </p>
        )}
        <div className="srt-buttons">
          <Button className="modal-cancel-btn" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            className="modal-yes-button"
            onClick={onSaveHandle}
            disabled={hasInvalidAscii || !TooltipInputText}
          >
            Save
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default CustomDropDown;
